<template>
<div class="chapter">
<div class="inner_page">
<p class="IVPh1" id="toc">Uncommon Decency</p>
<p class="IVPh3">Christian Civility in an Uncivil World</p>
<p class="IVPh3">Revised &amp; Expanded<span class="sgc-1"> </span></p>
<p class="IVPh3">Richard J. Mouw</p>
<p class="first"> </p>
<p class="IVPcenter"><img alt="IVP Books Imprint" src="Images/IVP_Books_Quarter.jpg"/></p>
<p class="IVPcenter"><a href="http://www.IVPress.com/books/" target="_blank">www.IVPress.com/books</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?f53de66e